import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase.config";

// Add cloud functions here inside enum CloudFunctions
// The key is the name you want to use in the frontend
// The value is the name of the function in Firebase
// nameYourWantToUseInFrontend = "nameOfTheFunctionInFirebase"
// Example: GetProfile = "getProfile"
enum CloudFunctions {
  setAdmin = "setAdminClaim",
  removeAdmin = "removeAdminClaim",
}

export async function cloudFunction(
  fnName: keyof typeof CloudFunctions,
  data = {}
) {
  const functionName = CloudFunctions[fnName];
  console.log(`Calling cloud function ${functionName} with ${data}`);

  return await httpsCallable(functions, functionName)(data);
}
